<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { queryUserInfo } from "@/api/user";
import { useStore } from "vuex";

const router = useRouter();
const store = useStore();
const nowVerse = ref("");
const nowIndexVerse = ref(0);
const nextVerse = ref("");
window.goscence = function () {
  router.replace("/randomView");
};
const randomVerse = ref(
  " 临安城外有西湖 <br> 湖之中为孤山路 孤山峙立 <br> 下有苏堤 界湖为二  <br> 东曰外湖 西曰里湖 <br> 湖北曰北山路 通以白堤 <br> 湖南曰南山路 登南高峰可远望钱塘江 <br> 湖滨多古庙 名祠，并有林 亭之胜 <br> 而灵隐 林和靖 岳武穆尤著 <br> 摘自 新国文"
);
onMounted(async () => {
  window.playshijv = () => {
    pointWord();
  };
  // const userInfo = await queryUserInfo()
  // store.commit({
  //   type: 'update',
  //   payload: {
  //     key: 'userInfo',
  //     value: userInfo
  //   }
  // })
  loadScript("cocos2d-js-min.js", () => {
    if (CC_PHYSICS_BUILTIN || CC_PHYSICS_CANNON) {
      loadScript("physics-min.js", window.boot);
    } else {
      window.boot();
    }
    window.gorouterPush = function () {
      // router.replace('/story')
      router.replace("/game");
    };
  });
});

const loadScript = (moduleName, cb) => {
  // console.log(store.state.userInfo.loginTotal);
  window.loginTotal = store.state.userInfo.loginTotal;
  function scriptLoaded() {
    document.body.removeChild(domScript);
    domScript.removeEventListener("load", scriptLoaded, false);
    cb && cb();
  }
  const domScript = document.createElement("script");
  domScript.async = true;
  domScript.src = "./cocos/" + moduleName;
  domScript.addEventListener("load", scriptLoaded, false);
  document.body.appendChild(domScript);
};

//加诗句
const pointWord = () => {
  nowIndexVerse.value++;
  let y = nextVerse.value.slice(-1);
  // console.log(y,y=='，<');
  if (y == "<") {
    nowIndexVerse.value += 3;
  }
  //  console.log(this.nowIndexVerse);
  nowVerse.value = randomVerse.value.substring(0, nowIndexVerse.value);
  nextVerse.value = randomVerse.value.substring(0, nowIndexVerse.value * 1 + 1);
  if (nowIndexVerse.value < randomVerse.value.length + 1) {
    var nowDate = new Date();
    if (nowDate.getHours() >= 1 && nowDate.getHours() < 12) {
      setTimeout(() => {
        pointWord();
      }, 400);
    } else {
      setTimeout(() => {
        pointWord();
      }, 260);
    }
  }
};
</script>

<template>
  <div class="full">
    <canvas id="GameCanvas"></canvas>
    <div id="splash" style="display: block">
      <div class="progress-bar stripes">
        <span style="width: 0%"></span>
      </div>
    </div>
    <div class="shijv">
      <div>
        <div class="poet">
          <!-- <h1>雨霖铃</h1> -->
          <p v-html="nowVerse"></p>

          <!-- <p>多情自古伤离别，更那堪，冷落清秋节！<br>
                今宵酒醒何处？杨柳岸，晓风残月。<br>
                此去经年，应是良辰好景虚设。<br>
                便纵有千种风情，更与何人说？<p> -->
          <!-- <p class="author">——&lt;宋&gt;<strong>柳永</strong></p> -->
        </div>
        <!-- <div class="nextViewHandle" @click="nextHandle"></div> -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.poet {
  /*wirting-mode实现竖直排版*/
  writing-mode: vertical-rl;
  position: fixed;
  top: 0;
  z-index: 999999999;
  color: #000;
  font-size: 17px;
  transition: all 11s ease;
  text-align: left;
  width: 100%;
  font-family: font3;
  // display: flex;
  // align-items: center;
  // text-align: right;
}

.poet h1 {
  margin-top: 4em;
}

.poet p:not(.author) {
  letter-spacing: 0.5em;
  line-height: 2.5em;
  font-size: 29px;
  margin: 0.6em;
}

.poet .author {
  text-align: right;
}

.nextViewHandle {
  width: 90px;
  height: 90px;
  background: url(public/ui/randomView/skip.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  bottom: 5%;
  right: 5%;
}

.titlebg {
  width: 100%;
  height: 100vh;
  background: url(public/ui/randomView/commonbg.jpg) no-repeat;
  background-size: 100% 100%;

  img {
    width: 70%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 21%;
  }
}

#stert {
  top: 74%;
  width: 43%;
}

.jzzfont {
  font-family: font1;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 74%;
}
</style>
